import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserGiftExperimentFunnels } from './UserGiftExperimentFunnels';
import { Hint } from '@src/components';
import { type GiftPackageStats } from './UserGiftFunnels';
export function UserGiftPaymentFunnel({ from, to, currency, valid, refreshVersion, onDenied }: { from?: string; to?: string; currency: string; valid: boolean; refreshVersion: number; onDenied: () => void }) {
  const { i18n } = useTranslation();
  const ru = i18n.language.startsWith('ru');
  const key = `${from}:${to}:${currency}:${refreshVersion}`;
  const [state, setState] = useState<{ key: string; data?: { funnel: Record<string, number>; packages: GiftPackageStats[]; experiments?: { group: string; viewed: number; clicked: number; buyers: number; purchases: number; revenue: number }[] }; error?: boolean }>();
  useEffect(() => {
    if (!valid) return;
    const controller = new AbortController();
    const params = new URLSearchParams({ currency });
    if (from) params.set('from', from);
    if (to) params.set('to', to);
    void fetch(`/api/admin/santa-gifts/credits?${params}`, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal }).then(async response => {
      if ([401,403].includes(response.status)) onDenied();
      if (!response.ok) throw Error();
      const data = await response.json();
      if (!controller.signal.aborted) setState({ key, data });
    }).catch(() => { if (!controller.signal.aborted) setState({ key, error: true }); });
    return () => controller.abort();
  }, [from, to, currency, valid, refreshVersion, key, onDenied]);
  if (!valid) return null;
  if (state?.key !== key) return <p role="status">{ru ? 'Загрузка…' : 'Loading…'}</p>;
  if (state.error || !state.data) return <Hint tone="error">{ru ? 'Не удалось загрузить воронку.' : 'Could not load funnel.'}</Hint>;
  return <UserGiftExperimentFunnels rows={state.data.experiments ?? []} currency={currency} />;
}
